import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../endpoint";
import type { FeeCategory, CreateFeeCategoryPayload } from "../types";

export const fetchFeeCategories = async (): Promise<{ categories: FeeCategory[]; knownFlagKeys: string[] }> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.FEE_CATEGORIES.LIST);
  return { categories: data.categories ?? [], knownFlagKeys: data.knownFlagKeys ?? [] };
};

export const createFeeCategory = async (payload: CreateFeeCategoryPayload): Promise<FeeCategory> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.FEE_CATEGORIES.CREATE, payload);
  return data.category;
};
